const RESET_PATH = '/reset-password';

/**
 * Recovery links may be returned to the configured Site URL rather than the
 * requested redirect path. Move every supported Supabase recovery-link format
 * to the reset screen before the auth client can consume the URL credentials.
 */
export const redirectRecoveryLink = () => {
  if (typeof window === 'undefined') return;

  try {
    const { pathname, search, hash } = window.location;
    if (pathname === RESET_PATH || pathname === '/set-password') return;

    const queryParams = new URLSearchParams(search);
    const hashParams = new URLSearchParams(hash.replace(/^#/, ''));
    const queryType = queryParams.get('type');
    const hashType = hashParams.get('type');
    const hasRecoveryCredentials =
      queryType === 'recovery' ||
      hashType === 'recovery' ||
      queryParams.has('token_hash') ||
      queryParams.has('token') ||
      queryParams.has('code') ||
      queryParams.has('error_description');

    if (hasRecoveryCredentials) {
      window.location.replace(`${RESET_PATH}${search}${hash}`);
    }
  } catch (error) {
    console.error('[Auth] Could not route password recovery link:', error);
  }
};

redirectRecoveryLink();